import type {PatrolRouteFormValues} from "../schemas";
import type {PatrolRouteStoreRequest, PatrolRouteVisitPayload} from "../types";

function emptyToNull(value: string | null | undefined): string | null {
  const trimmed = (value ?? "").trim();
  return trimmed === "" ? null : trimmed;
}

export const patrolRoutesSerializer = {
  serializeForm(
    values: PatrolRouteFormValues,
    options?: {persistColor?: boolean},
  ): PatrolRouteStoreRequest {
    const visits: PatrolRouteVisitPayload[] = values.visits.map((visit, index) => ({
      property_id: visit.property!.id,
      sort_order: index + 1,
      suggested_start_time: emptyToNull(visit.suggested_start_time),
      suggested_end_time: emptyToNull(visit.suggested_end_time),
      duties: emptyToNull(visit.duties),
    }));

    const payload: PatrolRouteStoreRequest = {
      name: values.name.trim(),
      description: emptyToNull(values.description),
      visits,
    };

    if (values.color) {
      payload.color = values.color;
    } else if (options?.persistColor) {
      payload.color = null;
    }

    return payload;
  },
};
